module.exports = __webpack_public_path__ + "img/Combined Shape.9b572c44.svg";